var map = {
	"./black.svg": "fb3b",
	"./blue.svg": "83c5",
	"./green.svg": "b5b2",
	"./red.svg": "4188",
	"./yellow.svg": "b5fb",
	"./yellow2.svg": "e862"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5615";